<style lang="scss" src='./ProvisioningStep7.scss' scoped ></style>
<template src="./ProvisioningStep7.html"></template>

<script>
import { mapState, mapMutations } from 'vuex';
import { ActivateSensor } from '@/api/api';

export default {
  name: 'ProvisioningStep7',
  data() {
    return ({
      sensor: null,
      loading: {
        activating: false,
      },
      uom: 'DEPTH',
    });
  },
  computed: {
    isCourseType(){
      if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
      || !this.course.facility_type){
        return true;
      }else{
        return false;
      }
    },
    
    holeNumber: function holeNumberFn() {
      if (this.hole && this.hole.hole_number) {
        return this.hole.hole_number;
      }
      return 'Other';
    },
    ...mapState('SensorProvisioning', {
      provisionPayload: (state) => state.provisionPayload,
      hole: (state) => state.hole,
    }),
    ...mapState('SensorList', {
      sensors: (state) => state.sensors,
    }),
    ...mapState(['course']), 
  },

  methods: {
    async activateSensor() {
      this.setLoading({ btnContinue: true });

      if(this.course.measurement_system == "METRIC"){
        this.provisionPayload.sensor_depth = this.provisionPayload.sensor_depth / 2.54;
        this.provisionPayload.prongs_depth = this.provisionPayload.prongs_depth / 2.54;
      }

      const activated = await ActivateSensor(this.sensor.sensor_id, this.provisionPayload)
        .then((sensorActivated) => {
          this.setSensors(
            this.sensors.map((sen) => ((sen.sensor_id === sensorActivated.sensor_id) ? sensorActivated : sen)),
          );
          return true;
        })
        .catch(() => false);
      this.setLoading({ btnContinue: false });

      return activated;
    },
    ...mapMutations('SensorProvisioning', ['setCanBack', 'setCanContinue', 'setLoading']),
    ...mapMutations('SensorList', ['setSensors']),
  },

  beforeCreate() {},

  created() {},

  activated() {
    this.setCanContinue(this.activateSensor);
    this.setCanBack(null);
  },

  mounted() {
    this.sensor = this.$store.state.sensor;
  },
};
</script>
